import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TitleComponent } from "./components/title/title.component";
import { CloseButtonComponent } from "./components/close-button/close-button.component";
import { PreviousPointTitleComponent } from "./components/previous-point-title/previous-point-title.component";
import { CurrentPointTitleComponent } from "./components/current-point-title/current-point-title.component";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TranslateModule,
    TitleComponent,
    CloseButtonComponent,
    PreviousPointTitleComponent,
    CurrentPointTitleComponent
],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderComponent {
  public previousPointTitle = input<string>();
  public currentPointTitle = input<string>();
}
